<mat-slide-toggle
  color="accent"
  [checked]="checked"
  (click)="$event.stopPropagation()"
  [disableRipple]="true"
  (change)="onValueChange.emit($event)"
>
  {{title}}
</mat-slide-toggle>
